import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { D60 } from '@store/models';

@Component({
    selector: 'app-60d-ui',
    templateUrl: './60d.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class D60Component {

    @Input() d60: D60[];
    @Output() dismiss = new EventEmitter();
    @Output() openClient = new EventEmitter<D60>();

    onOpenClient(d60: D60) {
        this.openClient.emit(d60);
    }

    onDismiss() {
        this.dismiss.emit();
    }

}
